import api from './api';

export interface Card {
  id: number;
  rfid_id: string;
  url: string;
  created_at: string;
  CustomerId: number;
}

export const cardService = {
  getMyCards: async (): Promise<Card[]> => {
    const response = await api.get('/cards/my-cards');
    return response.data;
  },

  getCardByRfidId: async (rfidId: string): Promise<Card> => {
    const response = await api.get(`/cards/${rfidId}`);
    return response.data;
  },

  createCard: async (card: Omit<Card, 'id' | 'created_at'>): Promise<Card> => {
    const response = await api.post('/cards', card);
    return response.data;
  },

  updateCard: async (rfidId: string, card: Partial<Card>): Promise<Card> => {
    const response = await api.put(`/cards/${rfidId}/url`, card);
    return response.data;
  },

  deleteCard: async (rfidId: string): Promise<void> => {
    await api.delete(`/cards/${rfidId}`);
  },
};
